import React from "react";
import PropTypes from "prop-types";
import styled from "@emotion/styled";

const Row = styled.div`
  display: flex;
  flex-direction: column;
  padding: 10px;
`;

const Ul = styled.ul`
  padding-left: 0px;
  list-style: none;
  line-height: normal;
  margin-bottom: 2rem;
`;

const Span = styled.span`
  color: #c7a878;
`;

const P = styled.p`
  margin-bottom: 2.5rem;
`;

const Hr = styled.hr`
  margin: 0;
`;

const ActionNeeded = styled.span`
  margin-bottom: 2.5rem;
`;

const EcodeReceipt = ({ supportEmail, supportPhone, brand }) => {
  return (
    <Row>
      <h2>What happens next?</h2>
      <Ul>
        <li>
          <b>1)</b> CardCash will verify the balance of your gift card(s).
        </li>
        <li>
          <b>2)</b> Upon successful order processing, CardCash will initiate
          your payment within one business day.
        </li>
        <li>
          <b>3)</b> Please retain the gift cards you've sold electronically
          until payment has been received.
        </li>
      </Ul>
      <P>
        Thank you for choosing {brand}. If you have any questions please contact
        us via <Span> {supportEmail} </Span>, or <Span> {supportPhone}.</Span>{" "}
        Please note, if the verified balance of the sold cards is different than
        the values you reported, then the payout amount will be adjusted
        accordingly.
      </P>
      <ActionNeeded>
        <Hr />
        Signature
      </ActionNeeded>
      <ActionNeeded>
        <Hr />
        Printed Name
      </ActionNeeded>
    </Row>
  );
};

EcodeReceipt.prototype = {
  supportEmail: PropTypes.string.isRequired,
  supportPhone: PropTypes.string.isRequired,
  brand: PropTypes.string.isRequired,
};

export { EcodeReceipt };
